const { default: CommonServices } = require("./common/common");

class EBooksSectionManagement extends CommonServices {
  constructor() {
    super("/ebooks");
  }
}

const ebooksSectionManagement = new EBooksSectionManagement();
export default ebooksSectionManagement;
